import axios from "@/axios";
import Util from "@/util/util";

export const namespaced = true;
const options = {
    'Content-Type': 'application/json'
}

const defaultData = {
  orderId: 0,
  tracerNumber: null,
  tracerAmount: null,
  tracerDate: null,
  voucherNumber: null,
  voucherDate: null,
  voucherAmount: null,
};

const defaultDisbursingCollection = {
    id: 0,
    orderId: 0,
    fundCitationId: undefined,
    abbreviation: "",
    totalAmount: 0,
    amountPaid: 0,
    tracerDate: '',
    tracer: "",
    fileId: '',
    voucherDate: "",
    voucher: "",
    outstandingBalance: 0
  }

export const state = {
    disbursingCollectionInfo: Object.assign({}, defaultData),
    disbursingCollectionInfoErrors: [],
    disbursingCollection: Object.assign({}, defaultDisbursingCollection),
    disbursingCollections: [],
    disbursingCollectionOutstandingBalance: null,
    status: false
};

export const getters = {
    disbursingCollectionInfo: state => {
        return state.disbursingCollectionInfo;
    },
    disbursingCollectionInformationStatus: state => {
        return state.status
    },
    disbursingCollectionInfoErrors: state => state.disbursingCollectionInfoErrors,
    allDisbursingInformationByOrderId: (state) => {
        return state.disbursingCollectionInfoLocal;
    },
    disbursingCollections: state => state.disbursingCollections,
    disbursingCollection: state => state.disbursingCollection,
    disbursingCollectionOutstandingBalance: state => state.disbursingCollectionOutstandingBalance
};

export const mutations = {
    SET_DISBURSING_COLLECTION_INFO(state, response) {
        state.disbursingCollectionInfo = Object.assign({}, defaultData, response.data)
        if (state.disbursingCollectionInfo.voucherAmount == null) {
            state.disbursingCollectionInfo.voucherAmount = 0.00;
        }
        if(state.disbursingCollectionInfo.tracerAmount == null){
            state.disbursingCollectionInfo.tracerAmount = 0.00;
        }
    },
    SET_STATUS(state, status) {
        state.status = status;
    },
    CLEAR_DATA(state) {
        state.disbursingCollectionInfo = Object.assign({}, defaultData),
        state.disbursingCollectionInfoErrors = [],
        state.disbursingCollection = Object.assign({}, defaultDisbursingCollection),
        state.disbursingCollections = [],
        state.disbursingCollectionOutstandingBalance = null,
        state.status = false
    },
    SET_ERRORS(state, data) {
        state.disbursingCollectionInfoErrors = data;
    },
    CLEAR_ERRORS(state) {
        state.disbursingCollectionInfoErrors = [];
    },
    SET_DISBURSEMENT_COLLECTIONS(state, response) {
        state.disbursingCollections = response;
    }, 
    SET_DISBURSEMENT_COLLECTION(state, response) {
        state.disbursingCollection = response;
    }, 
    SET_DISBURSEMENT_COLLECTION_OUTSTANDING_BALANCE(state, response) {
        state.disbursingCollectionOutstandingBalance = response;
    }, 
    CLEAR_DISBURSEMENT_COLLECTION(state) {
        state.disbursingCollection = Object.assign({}, defaultDisbursingCollection);
    }
};

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    updateDisbursementCollection({commit}, data) {
        commit("SET_DISBURSEMENT_COLLECTION", data);
    },
    clearDisbursingCollection({commit}) {
        commit("CLEAR_DISBURSEMENT_COLLECTION");
    },
    async getDisbursingCollectionInformationStatus({ commit }, id) {
        if (id == 0) {
            commit("SET_STATUS", false);
        } else {
            return await axios.get('/api/orderdisbursing/order/status/' + id)
            .then(({ data }) => {
                    if(data && data.length === 0) {
                        commit("SET_STATUS", true);
                      commit("CLEAR_ERRORS");
                    } else {
                        commit("SET_STATUS", false);
                      commit("SET_ERRORS", data);
                    }
                })
            }
    },
    async loadDisbursingCollectionInformation({ commit }, orderId) {
        try {
            commit("SET_DISBURSING_COLLECTION_INFO", await axios.get(`/api/orderdisbursing/${orderId}`));
        }
        catch (error) {
            console.log("ERROR LOADING DISBURSING COLLECTION INFORMATION: ", error); //not handelled
        }
    },
    async saveDisbursingCollectionInfoToServer({ commit, state, dispatch }, orderId) {
        return new Promise((resolve, reject) => {
            state.disbursingCollectionInfo.orderId = orderId
            state.voucherDate = Util.convertToDateOnly(state.voucherDate)
            
            axios.post("/api/orderdisbursing", state.disbursingCollectionInfo, {config: {showToast: true, message: 'Transaction Completion Module saved successfully'}})
            .then((response) => {
                return resolve(response);
                })
                .catch(function (error) {
                    return reject("There was an error saving the Disbursing Collection Information to the server.");
                })
        });
    },

    // new methods
    async updateAllDisbursingInfoByOrderId({commit, state}, data) {
        try {
            let orderId = data.orderId;
            let op = Object.assign(options, {});
            op.config = { showToast: false, message: "Data successfully retrieved!" };
            let ids = {
                'fundCitationIds': data.fundcitationIds
            };
            // Get Max Amount Paid Disbursement record for each fundcitation ids
            let temp = await axios.post(`/api/disbursements/byfundcitation/${orderId}`, ids, op);
            let d = temp.data;

            // // update each disbursement
            for(let i=0; i<d.length; i++) {
                try {
                    await axios.post(`/api/disbursements/${orderId}/${true}`, d[i], {config: {showToast: false}})
                } catch(err) {
                    console.log(err);
                } 
            }
            let d2 = await axios.get(`/api/disbursements/all/${orderId}`, op);
            commit('SET_DISBURSEMENT_COLLECTIONS', d2.data);
        } catch(err) {
            
        }
    },

    // new methods
    async loadAllDisbursingInfoByOrderId({commit}, orderId) {
        try {
            let op = Object.assign(options, {});
            op.config = { showToast: false, message: "Data successfully retrieved!" };
            let d = await axios.get(`/api/disbursements/all/${orderId}`, op);
            commit('SET_DISBURSEMENT_COLLECTIONS', d.data);
        } catch(err) {
            
        }
    },
    clearDisbursingCollection({commit}) {
        commit("CLEAR_DISBURSEMENT_COLLECTION");
    },
    async saveDisbursingCollection({state}, orderId) {
        return new Promise((resolve, reject) => {
            
            state.voucherDate = Util.convertToDateOnly(state.voucherDate)
            state.orderId = orderId;
            axios.post(`/api/disbursements/${orderId}`, state.disbursingCollection, {config: {showToast: true, message: 'Transaction Completion Module saved successfully'}})
                .then((response) => {
                    return resolve(response);
                })
                .catch(function (error) {
                    return reject("There was an error saving the Disbursing Collection Information to the server.");
                })
        });
    },
    async getDisbursingCollectionById({commit}, id) {
        await axios.get(`/api/disbursements/${id}`).then(d => commit("SET_DISBURSEMENT_COLLECTION", d.data))
    },
    async getDisbursingCollectionOutstandingBalance({commit}, id) {
        await axios.get(`/api/disbursements/outstandingbalancetotal/${id}`)
                    .then(d => {
                        commit("SET_DISBURSEMENT_COLLECTION_OUTSTANDING_BALANCE", d.data);
                    });
    },
    async deleteDisbursingCollection({}, id) {
        await axios.delete(`/api/disbursements/${id}`)
    }
};